import { Select } from '@mantine/core';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { speciesDataSelector } from '../../../store/slices/appSlice';
import {
  genusTableLoadedSelector,
  selectedSpeciesGenusSelector,
  setGenusTableLoaded,
  setOpenAddRecordModal,
  setSelectedSpeciesGenus,
} from '../../../store/slices/adminSlice';
import genusTableController from '../../../controllers/genusTableController';
import WFIDButton from '../../../components/WFIDButton/WFIDButton';

const GenusSampleContent = () => {
  const speciesData = useSelector(speciesDataSelector);
  const selectedSpeciesGenus = useSelector(selectedSpeciesGenusSelector);
  const genusTableLoaded = useSelector(genusTableLoadedSelector);
  const tableViewRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();

  const handleChange = (value: string | null) => {
    dispatch(setSelectedSpeciesGenus(value));
    if (!value) {
      genusTableController.destroyTable();
      dispatch(setGenusTableLoaded(false));
      return;
    }
    genusTableController.initializeTableController(tableViewRef, value);
  };

  return (
    <div className='admin-content-container'>
      <h1 className='main-h1'>Manage Genus Sample Data</h1>
      <h3 className='main-h3'>
        Edit sample records for species in a selected genus by adding, updating, or deleting entries.
      </h3>

      <div>
        <Select
          w='200px'
          searchable
          value={selectedSpeciesGenus}
          label='Select a Genus'
          disabled={false}
          onChange={handleChange}
          placeholder='Select a Genus'
          data={speciesData}
          clearable
        />
      </div>

      {genusTableLoaded && (
        <div className='add-record-button-container'>
          <WFIDButton bgColor='white' content='Add Record' onClick={() => dispatch(setOpenAddRecordModal(true))} />
        </div>
      )}
      <div className='genus-table-container' ref={tableViewRef} />
    </div>
  );
};

export default GenusSampleContent;
